import {
  GET_IMAGE_LOADING,
  GET_IMAGE_SUCCESS,
  GET_IMAGE_FAILURE,
} from '../actions/image';

const defaultState = {
  image: undefined,
  loading: false,
  error: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_IMAGE_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case GET_IMAGE_SUCCESS:
      return {
        ...state,
        image: action.payload,
        loading: false,
        error: false,
      };
    default:
      return state;
  }
};

export const imageStateSelector = (state) => state.image;
